
































import { defineComponent, ref, watch } from '@vue/composition-api';
import { debounce } from '@/bundles/App/helpers';
import { useActivityGroup } from '@/bundles/ActivityGroup/composables/useActivityGroup';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';
import { usePhysicalExercise } from '@/bundles/VideoContent/composables/usePhysicalExercise';

export default defineComponent({
  emits: ['list:refresh'],

  setup(_, {emit}) {
    const { loading: exercisesLoading, exercises, fetchExercises: fetch } = usePhysicalExercise();

    const exerciseKeyword = ref('');
    const selected = ref(null);

    function keywordSearch() {
      if (!exerciseKeyword.value?.length) {
        return fetch({});
      }
      fetch({ keyword: exerciseKeyword.value });
    }

    const searchWrapper = debounce(keywordSearch, 500);
    watch(exerciseKeyword, () => {
      searchWrapper();
    });

    const { addToGroup, addToGroupLoading } = useActivityGroup();

    async function submitEventHandler() {
      if (!selected.value) {
        return;
      }
      await addToGroup(ActivityGroupType.physical, { record_id: selected.value! });
      clearForm();
      emit('list:refresh');
    }

    function clearForm() {
      selected.value = null;
      exerciseKeyword.value = '';
    }

    return {
      exerciseKeyword,
      selected,
      exercises,
      addToGroupLoading,
      exercisesLoading,
      submitEventHandler,
    };
  },
});
